export default __webpack_public_path__ + "static/media/grafico_04.fca735ac.png";